import "./NetWorth.css";
import { type BillionaireItem, type ForbesResult, escapeHtml, formatChange, formatWorth, updatedLabel } from "./BillionaireTypes";

function history(person: BillionaireItem): string {
  const rows = (person.history || []).slice(0, 8);
  if (rows.length < 2) return "";
  return `<section class="networth-history"><h2>Tracked net worth</h2>${rows.map(row => `<div><span>${escapeHtml(new Date(row.captured_at).toLocaleString())}</span><strong>${escapeHtml(formatWorth(row.net_worth_usd))}</strong><span>#${row.rank}</span></div>`).join("")}</section>`;
}

export function renderNetWorth(container: HTMLElement, person: BillionaireItem, sourceUrl: string, forbes?: ForbesResult): void {
  const questions = (person.related_questions || []).slice(0,4);
  container.innerHTML = `
    <div class="networth-shell">
      <section class="networth-answer">
        <div class="networth-person-row">
          ${person.image_url ? `<img src="${escapeHtml(person.image_url)}" alt="${escapeHtml(person.name)}" referrerpolicy="no-referrer" />` : ""}
          <div><div class="networth-label">${escapeHtml(person.name)}/Net worth (2026)</div><div class="networth-value">${escapeHtml(formatWorth(person.net_worth_usd))}</div><div class="networth-sub">Current cached Forbes estimate · World rank #${person.rank}</div><div class="networth-change">${escapeHtml(formatChange(person))}</div></div>
        </div>
        <div class="networth-updated">${escapeHtml(updatedLabel(person.last_seen_at))} · AyeSearch snapshot tracking</div>
      </section>

      ${history(person)}

      <section class="networth-paa">
        <h2>People also ask</h2>
        ${questions.map(q => `<details><summary>${escapeHtml(q)}</summary><div>${escapeHtml(q.includes(person.name) ? `${person.name} is currently tracked at ${formatWorth(person.net_worth_usd)} and rank #${person.rank}.` : `AyeSearch billionaire tracking is based on the current cached Forbes Real-Time Billionaires ranking.`)}</div></details>`).join("")}
      </section>

      <section class="networth-forbes">
        <div class="networth-forbes-brand">Forbes</div>
        <a href="${escapeHtml(forbes?.url || person.profile_url || sourceUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(forbes?.url || person.profile_url || sourceUrl)}</a>
        <h2><a href="${escapeHtml(forbes?.url || person.profile_url || sourceUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(forbes?.title || `${person.name} - Forbes Real-Time Billionaires`)}</a></h2>
        <p>${escapeHtml(forbes?.description || `Forbes ranking data for ${person.name}, including current estimated net worth and world rank.`)}</p>
      </section>
    </div>
  `;
}
